import { render, staticRenderFns } from "./BasicHeader.vue?vue&type=template&id=ea607ab0&scoped=true&"
import script from "./BasicHeader.vue?vue&type=script&lang=js&"
export * from "./BasicHeader.vue?vue&type=script&lang=js&"
import style0 from "./BasicHeader.vue?vue&type=style&index=0&id=ea607ab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea607ab0",
  null
  
)

export default component.exports